import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import styled from 'styled-components';

export const LaneStats = () => {
  const {
    AuctionStore: {
      laneMetrics,
    },
  } = useStores();

  return (
    <AuctioneerStatsContainer>
      <div>Lane Stats</div>
      <div>
        <div>
          <div>Units Remaining:</div>
          <div>236</div>
        </div>
        <div>
          <div>Active Bidders:</div>
          <div>{laneMetrics ? laneMetrics.totalClientsInLane : '-'}</div>
        </div>
        <div>
          <div>Avg. PtoB:</div>
          <div>97%</div>
        </div>
        <div>
          <div>Avg. Sell Time:</div>
          <div>1m 34s</div>
        </div>
        <div>
          <div>Subject To %:</div>
          <div>14%</div>
        </div>
        <div>
          <div>No Sale %:</div>
          <div>4%</div>
        </div>
      </div>
    </AuctioneerStatsContainer>
  );
};

export default observer(LaneStats);


export const AuctioneerStatsContainer = styled.div`
  grid-area: stats;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #eee;
  border: 1px solid gray;
  padding: 0px 5px;
  font-size: 1.4em;
  font-weight: bold;
  > div:first-child {
    margin-top: 10px;
    font-size: 1em;
  }
  > div:not(:first-child) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      font-size: .8em;
      font-weight: normal;
      text-transform: none;
      padding: 5px;
      width: 100%;
      > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: inherit;
        > div {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          width: inherit;
          padding: 3px;
          :first-child {
            display: flex;
            justify-content: flex-end;
            font-weight: bold;
            width: 60%;
          }
          :last-child {
            padding-left: 5px;
            width: 40%;
          }
        }  
      }
    }
  }
`;
